import React from 'react';
import { twMerge } from '@/utils';

interface ILinkButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactChildren,
  className?: string;
  color?: ButtonColors;
  onClick: (() => void) | React.MouseEventHandler<HTMLButtonElement>;
}

const LinkButton = ({ children, className, color = 'purple', onClick, ...rest }: ILinkButtonProps) => (
  <button
    className={twMerge('btn', `btn--link-${color}`, className)}
    type="button"
    onClick={onClick}
    {...rest}
  >
    {children}
  </button>
);

export default LinkButton;
